var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.337,
    height: 20.337,
    viewBox: "0 0 20.337 20.337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.302 -45.302)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.302 45.302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.363,11.269a5.094,5.094,0,1,0,5.094,5.094A5.1,5.1,0,0,0,16.363,11.269Z",
    transform: "translate(-6.194 -6.194)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.367,3.578a.994.994,0,0,1-.994-.993V.994a.994.994,0,0,1,1.988,0v1.59A.994.994,0,0,1,21.367,3.578Z",
    transform: "translate(-20.373)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.175 16.759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.367,37.215a.994.994,0,0,0-.994.994V39.8a.994.994,0,1,0,1.988,0v-1.59A.994.994,0,0,0,21.367,37.215Z",
    transform: "translate(-20.373 -37.215)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.538 2.687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.573,8.788a1,1,0,0,1,0-1.406L33.7,6.258A.994.994,0,1,1,35.1,7.664L33.979,8.788A.994.994,0,0,1,32.573,8.788Z",
    transform: "translate(-32.282 -5.967)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.687 14.538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.788,32.574a.993.993,0,0,0-1.406,0L6.258,33.7A.994.994,0,0,0,7.663,35.1l1.124-1.125A.993.993,0,0,0,8.788,32.574Z",
    transform: "translate(-5.967 -32.283)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.759 9.175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.215,21.367a.994.994,0,0,1,.994-.994H39.8a.994.994,0,1,1,0,1.987h-1.59A.993.993,0,0,1,37.215,21.367Z",
    transform: "translate(-37.215 -20.373)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.578,21.367a.994.994,0,0,0-.994-.994H.994a.994.994,0,1,0,0,1.987h1.59A.993.993,0,0,0,3.578,21.367Z",
    transform: "translate(0 -20.373)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.538 14.539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.573,32.575a1,1,0,0,1,1.406,0L35.1,33.7A.994.994,0,0,1,33.7,35.1L32.573,33.98A.993.993,0,0,1,32.573,32.575Z",
    transform: "translate(-32.281 -32.284)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.687 2.687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.788,8.788a.994.994,0,0,0,0-1.406L7.663,6.259A.994.994,0,0,0,6.258,7.664L7.382,8.788A.993.993,0,0,0,8.788,8.788Z",
    transform: "translate(-5.966 -5.968)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.a95ac4e8141bf2d68bdbce600cd246da.svg";
export { ForwardRef as ReactComponent };